import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { useDeleteFloor } from "entities/floors/api/useDeleteFloor"
import { useFloorFragment } from "entities/floors/model/useFloorFragment"

import { DeleteFloorOverlayModel } from "../DeleteFloorOverlay"
import { DeleteFloorOverlayConnectorProps } from "../DeleteFloorOverlayConnector"

export function useDeleteFloorOverlayModel({
  payload
}: DeleteFloorOverlayConnectorProps): DeleteFloorOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const { projectID, floorID } = payload
  const floor = useFloorFragment(floorID)
  const [deleteFloor] = useDeleteFloor()

  const handleDelete = useEvent(() => {
    deleteFloor({ id: floorID }, projectID)
    closeOverlay()
  })

  return {
    payload,
    floor,
    onDelete: handleDelete,
    onClose: closeOverlay
  }
}
